module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-leave-red-7ddb02.svg";